import axios from 'axios'
import {useApiKey} from 'providers/EnvironmentProvider'

export const useVentrataClient = (apiKey?: string) => {
  const defaultApiKey = useApiKey()
  const resultApiKey = apiKey || defaultApiKey

  const ventrata = axios.create({
    baseURL: 'https://checkout-api.ventrata.com/octo',
    headers: {
      Authorization: `Bearer ${resultApiKey}`,
      'Octo-Capabilities': 'ventrata/checkout',
    },
  })

  return ventrata
}
